import { Reducer } from 'redux';
import { InitialMappingData, MappingTypes } from './types';

const INITIAL_STATE: InitialMappingData = {
  name: '',
  mappingId: '',
  fieldsToParse: {
    name: '',
    numberCargo: '',
    orderCode: '',
    address: '',
    address2: '',
    weight: '',
    corporateName: '',
    fantasyName: '',
    nf: '',
    price: '',
    latitude: '',
    longitude: '',
    cep: '',
    weightUnity: '',
  },
};

const reducerMapping: Reducer<InitialMappingData> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case MappingTypes.MAPPING_DATA_SUCCESS: {
      const newState = { ...state };
      newState.name = action.payload.name;
      newState.fieldsToParse = action.payload.fieldsToParse;
      newState.mappingId = action.payload.mappingId;
      return newState;
    }

    case MappingTypes.MAPPING_DATA_FAILURE: {
      const newState = { ...INITIAL_STATE };
      return newState;
    }

    default:
      return state;
  }
};

export default reducerMapping;
